import React from 'react';
import Container from '../../atoms/Container';
import Styles from './BlogTextList.css';

function BlogTextList({ textList, title, ...props }) {
  return (
    <>
      <article {...props} className="blog-tx-list">
        <Container extraPadding>
          {title && <h3>{title}</h3>}
          <ul>
            {textList.map((t, i) => {
              return (
                <li key={`blog-tx-list-${i}`}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t,
                    }}
                  />
                </li>
              );
            })}
          </ul>
        </Container>
      </article>
      <style jsx>{Styles}</style>
    </>
  );
}

BlogTextList.defaultProps = {
  textList: [],
};

export default BlogTextList;
